import React from 'react';
import PropTypes from 'prop-types';
import { TagItem } from './tag-item';

const TagItems = ({ data, onRemove }) => {
  return (
    <div className="flex flex-wrap">
      {data && data.map((item) => (
        <div className="mr-3 mb-3" key={item.value}>
          <TagItem
            value={item.label}
            onClose={() => onRemove(item)}
          />
        </div>
      ))}
    </div>
  )
}

TagItems.propTypes = {
  data: PropTypes.array,
  onRemove: PropTypes.func
}

TagItems.defaultProps = {
  data: [],
  onRemove: () => {}
}

export { TagItems }

